module.exports = __webpack_public_path__ + "static/media/bg1.5961a9b2.jpg";